// - Headers Payroll
export default [
    {
        text: '#',
        value: 'id',
    },
    {
        text: 'Encargado',
        value: ({ g_user }) => {
            return (
                g_user.hr_employee.names +
                ' ' +
                g_user.hr_employee.last_name1 +
                ' ' +
                g_user.hr_employee.last_name2
            )
        },
    },
    {
        text: 'Periodo',
        align: 'right',
        value: ({ period_year, period_month }) => {
            switch (period_month) {
                case 1:
                    return 'Enero' + ' - ' + period_year
                case 2:
                    return 'Febrero' + ' - ' + period_year
                case 3:
                    return 'Marzo' + ' - ' + period_year
                case 4:
                    return 'Abril' + ' - ' + period_year
                case 5:
                    return 'Mayo' + ' - ' + period_year
                case 6:
                    return 'Junio' + ' - ' + period_year
                case 7:
                    return 'Julio' + ' - ' + period_year
                case 8:
                    return 'Agosto' + ' - ' + period_year
                case 9:
                    return 'Septiembre' + ' - ' + period_year
                case 10:
                    return 'Octubre' + ' - ' + period_year
                case 11:
                    return 'Noviembre' + ' - ' + period_year
                case 12:
                    return 'Diciembre' + ' - ' + period_year
            }
            return period_year
        },
    },
    {
        text: 'emisión',
        align: 'right',
        format: 'date',
        value: 'emission_date',
    },
    {
        text: 'pago',
        align: 'right',
        format: 'date',
        value: 'payment_date',
    },
    {
        text: 'Autorizado',
        value: 'authorized',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'Previred',
        value: 'has_generated_previred_format',
        align: 'center',
        format: 'boolean',
    },
    {
        text: 'Total',
        align: 'right',
        format: 'currency',
        value: ({ hr_detail_payrolls }) => {
            return hr_detail_payrolls.reduce(
                (total, curr) =>
                    total + curr.hr_salary_settlement.liquid_salary,
                0
            )
        },
    },
    {
        text: 'creación',
        align: 'right',
        format: 'datetime',
        value: 'created_at',
    },
]
